import { payPointsKeys } from "Api/Queries/PayPoints/usePayPointsQuery";
import type {
  AssignPayPointRequest,
  ErrorResponse,
  PayPointBaseDto,
} from "Infrastructure/Api/Api";
import { putPayPointsPublicIDAssignNfcCard } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { payPointKeys } from "Api/Queries/PayPoints/usePayPointQuery";

type Props = {
  onSuccess?: (publicID: string) => void;
  onError?: (error: ErrorResponse) => void;
};

type Parameters = {
  data: AssignPayPointRequest;
  publicID: string;
};

export const useAssignNFCToPayPoint = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation<PayPointBaseDto, ErrorResponse, Parameters>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: Parameters) =>
        putPayPointsPublicIDAssignNfcCard(data, publicID),
    ),
    onSuccess: ({ name, publicID }) => {
      queryClient.invalidateQueries({
        queryKey: payPointsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: payPointKeys.byId(publicID),
      });
      toast.success(t(Resources.Hooks.Paypoint.AssignNfcCardSuccess, { name }));
      onSuccess?.(publicID);
    },
    onError: (error: ErrorResponse) => {
      toast.error(t(Resources.Hooks.Paypoint.AssignNfcCardError));
      onError?.(error);
    },
  });
};
